'use strict'

var $ = require('jquery');
var AnimationEasing = require('../lib/AnimationEasing.js');
var isAPersonActive = false;
var Analytics = require('@plaudit/analytics').Analytics;
var myAnalytics = Analytics.getInstance();

function init() {
	var $personGroup = $('.peopleGroup__people');
	if ($personGroup.length === 0)
		return;

	// Clicking on closed will open, otherwise closes
	$personGroup.on('click', '.person--hasDescription', function(event) {
		event.preventDefault();

		var $this = $(this);

		if ($this.hasClass('person--active')) {
			var $detail = $('.person__detail');
			collapse($detail, cleanup);
		} else {
			activate($this);
		}
	});

	// Setup close
	$personGroup.on('click', '.person__detail--close', function(e) {
		e.preventDefault();
		var $detail = $('.person__detail');
		collapse($detail, cleanup);
	});

	// Close everything if resize
	// This causes a bug on touch devices - scrolling the page up and down causes the text to randomly disappear, leaving a big white space
//	$(window).resize(function() {
//		cleanup();
//	});

	// If click on anything when outside an open person
	$('body').on('click', function(e) {
		if (isAPersonActive && e.target !== undefined) {
			var $this = $(e.target);
			if ($this.closest('.person, .person__detail').length == 0) {
				// Did not click on a person
				var $detail = $('.person__detail');
				collapse($detail, cleanup);
			}
		}
	});
}

function collapse($detail, complete) {
	$detail.stop(true).animate({
		height: 0
	}, {
		duration: 400,
		easing: 'easeInOutQuad',
		complete: complete
	});
}

function activate(element, event) {
	// Ensure no other .person is also marked active
	$('.person').removeClass('person--active');

	// Trigger GA event
	var label =
		element[0]
			.getElementsByClassName('person__name')[0]
			.textContent
			.trim();
	myAnalytics.trackEvent('People Group', 'Expand', label);

	// Mark person active
	element.addClass('person--active');
	$('.peopleGroup__people').addClass('person--selected');

	// Create detail area and populate it's contents
	var newContent = element.find('.person__bio').clone();

	// Find .person to insert after by finding when they drop to new column
	var insertDetailsAfter = element;
	var elementTop = element.offset().top;
	var result = element.nextAll('.person');
	for (var i=0; i < result.length; i++) {
		if (result.eq(i).offset().top > elementTop) {
			break;
		} else {
			insertDetailsAfter = result.eq(i);
		}
	}

	var $detail = $('.person__detail');

	var switchToNewContent = function() {
		// Insert (or move)
		insertDetailsAfter.after($detail);

		// Add new bio below current bio. We will then animate in the new one
		var $detailContents = $detail.find('.person__detailsContents');
		var innerContentDiv = $('<div class="person__detailsContentsInner"/>');
		innerContentDiv.append(newContent).append('<a class="person__detail--close">close</a>');
		innerContentDiv.appendTo($detailContents);
		var oldInnerContentDiv = $detail.find('.person__detailsContentsInner').not(innerContentDiv);

		// Animate transition
		// Grow to exact new height
		var duration = 600;
		var newHeight = innerContentDiv.outerHeight();
		if (oldInnerContentDiv.length !== 0) {
			oldInnerContentDiv.stop(true).animate({opacity: 0}, {duration: duration * 0.75, easing: 'easeInOutQuad',
				complete: function () {
					oldInnerContentDiv.remove();
				}
			});
			innerContentDiv.stop(true).delay(duration * 0.45);
		}
		innerContentDiv.animate({opacity: 1}, {duration: duration, easing: 'easeInOutQuad'});
		$detail.addClass('person__detail--active');
		$detail.stop(true).animate({height: newHeight}, {duration: duration, easing: 'easeInOutQuad'});
	}

	if (
			$detail.length > 0
			&& insertDetailsAfter.offset().top !== $detail.prev('.person').offset().top
			) {
		// Detail already open but open in a different row so we must collapse completely then open
		collapse($detail, function() {
			switchToNewContent();
		});
	} else {
		// New
		if ($detail.length === 0) {
			$detail = $(
					'<div class="person__detail">'
					+ '	<div class="person__detailsContents">'
					+ '	</div>'
					+ '</div>');
		}
		switchToNewContent();
	}

	// Scroll down to person
	var elementTop = element.offset().top;
	if ($('html, body').scrollTop() < elementTop) {
		$('html, body').animate({
				scrollTop: elementTop
			}, 'slow');
	}

	isAPersonActive = true;
}

function cleanup() {
	isAPersonActive = false;

	$('.person').removeClass('person--active');
	$('.peopleGroup__people').removeClass('person--selected');

	$('.person__detail').removeClass('person__detail--active');
}

var PeopleGroup = {
	init: init,
	cleanup: cleanup
};

module.exports = PeopleGroup;
